import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import StudentWithAvatar from '../../students/StudentWithAvatar'

import { ReactComponent as CloseIcon } from '../../../assets/images/common/icons/modal-X-icon.svg'
import { ReactComponent as PersonIcon } from '../../../assets/images/common/icons/person-icon.svg'
import { ReactComponent as FamilyIcon } from '../../../assets/images/common/icons/family-icon.svg'
import { ReactComponent as CallIcon } from '../../../assets/images/common/icons/call-icon.svg'
import { ReactComponent as MailIcon } from '../../../assets/images/common/icons/mail-icon.svg'

import { calculateAge, genderLabel } from '../../../utility/userHelper'

import classes from './DetailsDrawer.module.scss'
import colors from '../../../assets/styles/globals.scss'
import React from 'react'

const DetailsDrawer = ({ student, onClose }) => {
  const navigate = useNavigate()

  const familyAdmin = student.family?.users.filter(user => user.familyAdmin)[0]

  return (
    <>
      <div className={classes.drawer}>
        <header>
          <button className={classNames('d-flex align-items-center', classes.closeButton)} onClick={onClose}>
            <CloseIcon className={classNames(classes.closeIcon)} aria-hidden='true' />
          </button>
        </header>
        <main>
          <div className='d-flex mb-5'>
            <StudentWithAvatar student={student} avatarClassName='small-round-image-wrapper' />
            <div className='d-flex flex-column flex-grow-1 pr-3'>
              <h6 className='mb-1 font-weight-bold'>{student.firstName} {student.lastName}</h6>
              <span>
                {student.birthdate !== null && `${calculateAge(student.birthdate)}yrs / `}
                {genderLabel[student.gender]}
              </span>
            </div>
          </div>
          <div className={classes.quickActions}>
            <h6 className='font-weight-bold mb-0'>Quick Actions & Administration</h6>
            <button
              className={classes.quickButton}
              onClick={() => navigate(`/profile/${student.id}`)}
            >
              <PersonIcon width={22} height={22} color={colors.secondaryColor} />
              View Profile
            </button>
            <button
              className={classes.quickButton}
              onClick={() => navigate(`/members/families/${student.family.id}`)}
            >
              <FamilyIcon width={22} height={22} color={colors.secondaryColor} />
              View Family Page
            </button>
          </div>
          <div className={classes.contact}>
            <h6 className='font-weight-bold mb-0'>Contact Family Admin</h6>
            <div className={classes.profile}>
              <StudentWithAvatar student={familyAdmin} />
              <div className={classes.info}>
                <div className={classes.name}>
                  <span>{familyAdmin.firstName} {familyAdmin.lastName}</span>
                  <span className={classes.familyAdminLabel}>Family Admin</span>
                </div>
                <span>
                  {familyAdmin.birthdate !== null && `Age ${calculateAge(familyAdmin.birthdate)} / `}
                  {genderLabel[familyAdmin.gender].at(0)}
                </span>
              </div>
            </div>
            {familyAdmin.phonePrefix && familyAdmin.phone && (
              <button
                className={classes.contactButton}
                onClick={() => null}
              >
                <CallIcon className={classes.contactIcon} />
                {familyAdmin.phonePrefix} {familyAdmin.phone || ''}
              </button>
            )}
            <button
              className={classes.contactButton}
              onClick={() => null}
            >
              <MailIcon className={classes.contactIcon} />
              {familyAdmin.email || '-'}
            </button>
          </div>
        </main>
      </div>
      <div
        tabIndex={0}
        role='button'
        onKeyDown={() => null}
        className={classes.drawerOverlay}
        onClick={onClose}
      />
    </>
  )
}

DetailsDrawer.propTypes = {
  student: PropTypes.object.isRequired,
  onClose: PropTypes.func,
}

export default DetailsDrawer
